import styled from "styled-components";
import { colorBrandPrimary } from "src/global.style";

export const LinkFooter = styled.a`
  position: relative;
  opacity: 0.7;
  color: #000;
  font-family: "Work Sans";
  font-size: 12.865px;
  font-style: normal;
  font-weight: 700;
  line-height: 142.8%;
  text-decoration-line: underline;
  cursor: pointer;
`;

export const TooltipLink = styled(LinkFooter)`
  width: 100%;
  padding-right: 30px;
  line-height: 12px;

  span {
    position: relative;
    font-weight: 700;

    cursor: pointer;
    text-decoration: underline;

    img {
      position: relative;
      top: 4px;
      margin-left: 3px;
    }
  }
`;

export const TooltipTitle = styled.div`
  display: flex;
  position: relative;
  gap: 5px;

  span {
    color: ${colorBrandPrimary.verdeTaverna};
    font-family: "Work Sans";
    font-weight: 400 !important;
    font-size: 14px;
    line-height: 24px;
    font-style: normal;
    line-height: normal;
    text-decoration: underline;
    cursor: text !important;
  }

  button {
    padding: 3px 0 3px 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: -10px;
    right: -5px;
    height: min-content;
    width: min-content;

    background: transparent;
    border: none;

    @media (max-width: 767px) {
      padding: 7px;
    }
  }
`;

export const TooltipDescription = styled.p`
  width: 95%;
  color: ${colorBrandPrimary.verdeTaverna};
  font-family: "Work Sans";
  font-weight: 400;
  line-height: 24px;
  font-size: 14px;
  font-style: normal;
  line-height: normal;
`;
